<kiene-kiene-table [tableDescriptor]="tableDescriptor">
    <!--<div toolbarElementTop>
        <p *ngIf="anzahlFehler > 0">
            <a style="color: red; font-weight: bold" [routerLink]="['/belege/abgabebelege']">{{ anzahlFehler }}x
                Beleg/Stammdaten fehlerhaft!</a>
        </p>
    </div>-->
</kiene-kiene-table>
